<template>
  <div class="bookDetails-container app-container">
    <el-card class="bookDetails" :body-style="{ padding: '20px' }">
      <div class="bookDetails-header">
        <h4>{{ $t("content.books.bookDetails") }}</h4>
        <div class="bookDetails-handle">
          <button class="global-button-style" @click="$router.back()">
            {{ $t("commonMsg.back") }}
          </button>
        </div>
      </div>

      <detailsContent
        :bookData="bookData"
        @addBookList="addBookList"
        @outBookList="outBookList"
      />
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('content.books.content')" name="first">
          <!--<div v-html="bookData.info"></div>-->
          <div>
            {{ bookData.info ? bookData.info : $t("commonMsg.none") }}
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('content.books.directory')" name="second">
          <div>
            {{ bookData.catalog ? bookData.catalog : $t("commonMsg.none") }}
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('content.books.author')" name="third">
          <div>
            {{
              bookData.authorInfo ? bookData.authorInfo : $t("commonMsg.none")
            }}
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-card class="bookDetails-comment" :body-style="{ padding: '20px' }">
      <div class="bookDetails-comment-header">
        <h4>{{ $t("content.books.comment") }}</h4>
        <div class="bookDetails-comment-btn">
          <button class="global-button-style">{{ $t("commonMsg.del") }}</button>
        </div>
      </div>
      <!-- card body -->
      <div>
        <div class="remarkList">
          <span>{{ $t("content.books.allComment") }}（3900+）</span>
          <span>{{ $t("content.books.good") }}（22+）</span>
          <span>{{ $t("content.books.normal") }}（22+）</span>
          <span>{{ $t("content.books.bad") }}（22+）</span>
        </div>
        <div class="remarkContent">
          <el-row>
            <el-col :span="5">
              <div class="grid-content bg-purple">
                <img src="" alt="" />
                <span>nandero_jd</span>
              </div>
            </el-col>
            <el-col :span="17">
              <div class="grid-content bg-purple-light remarkItem">
                <el-rate v-model="rate"></el-rate>
                <div>不错不错点个赞，三少继续加油哦，唐家三少（糖加三勺）</div>
                <div>2017-08-20 12:46:22</div>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="grid-content bg-purple">
                <el-checkbox class="bookItem-checkbox"></el-checkbox>
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>
      </div>
    </el-card>

    <transition-group name="fade">
      <addBookList
        key="addBookList"
        :channles="channlesData"
        @confirmEvn="confirmEvn"
        v-if="showAddBookList"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import addBookList from "@/components/addBookList";
import detailsContent from "../components/detailsContent";

export default {
  components: {
    addBookList,
    detailsContent
  },
  computed: {
    ...mapGetters(["showAddBookList"])
  },
  data() {
    return {
      rate: 4,
      sourceType: parseInt(this.$route.query.source) || 0,
      idTab: parseInt(this.$route.query.idTab),
      bookData: {},
      channlesData: [],
      activeName: "first"
    };
  },
  methods: {
    getBookDetails() {
      this.$http
        .getBookDetails(this.$route.query.id, {
          source_type: this.$route.query.source
        })
        .then(res => {
          this.bookData = res;
        });
    },

    getBookChannels() {
      return new Promise((resolve, reject) => {
        this.$http.getBookChannels().then(res => {
          this.channlesData = res.data.rows;
          resolve("ok");
        });
      });
    },
    async addBookList() {
      await this.getBookChannels();
      this.$store.commit("windowHandle", "showAddBookList");
    },
    outBookList() {
      let obj = {
        status: this.bookData.status !== 1 ? 1 : 0
      };
      this.$http
        .updateBook(this.$route.query.id, obj)
        .then(res => {
          this.bookData.status !== 1
            ? this.elMsg(this.$t("alertMsg.soldOnSuccess"), "success")
            : this.elMsg(this.$t("alertMsg.soldOutSuccess"), "success");
          this.getBookDetails();
        })
        .catch(err => {});
    },
    confirmEvn(group) {
      let obj = {
        source_type: this.sourceType
      };

      if (this.sourceType === 4) {
        obj.ebook_id = this.bookData.ebook_id;
      } else {
        obj.ids = this.bookData.id;
      }
      this.$http.moduleAddBooks(group.id, obj).then(res => {
        this.elMsg(this.$t("alertMsg.addSuccess"), "success");
      });
    }
  },
  mounted() {
    this.getBookDetails();
  }
};
</script>

<style lang="scss" scoped>
.bookDetails-container {
  padding: 20px;
  .bookDetails-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border-bottom: 1px solid $globalBorderColor;
  }
  .bookDetails-comment {
    margin-top: 20px;
    .bookDetails-comment-header {
      @extend .bookDetails-header;
    }
  }
}

.remarkList {
  padding: 20px 0 0 20px;
  span {
    margin-right: 20px;
  }
}

.remarkContent {
  padding: 10px 20px;
  margin-top: 10px;
  .el-row {
    .remarkItem {
      > div:not(:first-child) {
        margin-top: 10px;
      }
    }
  }
}
</style>
